var bodyScrollLockOptions = {
  reserveScrollBarGap: false,
};

var Shopify = Shopify || {};

var shop_domain = 'https://evestore.com';
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, true);
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      this.rootElement.addEventListener(eventType, this.handle, false);
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, useCapture);
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class Popup {
  constructor(element, popup) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    
    if(popup){
    this.pageOverlayElement = document.querySelector('.pageOverlayCart');
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }
   
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    document.addEventListener("open:popup", this.openNewsletter.bind(this));
    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openNewsletter() {

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById('Newsletter_popup');
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus = this.element.querySelector("[data-scrollable]");

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
    bodyScrollLock.disableBodyScroll(focus);
  }

  openModal() {
    var _this = this;

    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.getAttribute("aria-controls")
    );
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    if (this.activeModal){
      var focus = this.activeModal.querySelector("[data-scrollable]");
    }


      bodyScrollLock.disableBodyScroll(focus);
      document.body.classList.add("scrollLock");
    setTimeout(() => {
      trapFocus(this.activeModal);

    }, 500);

  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus = this.activeModal.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    this.activeModal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("scrollLock");
    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}


class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight(){
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener('resize', this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".ProductSliderCell--Zoom",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
  }
  photoswiperClose() {
    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
        index = 0;
    if(this.slideshow){
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      var index_currentSlide = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index_currentSlide].querySelector('.ProductSlider--Element').getAttribute(
        'data-image-position'
      )
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }



    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }
    var images = [];

    new DomHelper().getSiblings(target, null, true).forEach(function (item) {
      if (item.classList.contains("ProductSliderCell--Zoom") && item.querySelector("img")) {
          images.push(item.querySelector("img"));
      }
    });
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(
        target
          .querySelector(".ProductSlider--Element")
          .getAttribute("data-image-position")
      )
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: new RevolutionImage().getSizedImageUrl(
          image.getAttribute("data-original-src"),
          requestedWidth + "x" + requestedHeight
        ),
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
              ".mainSwiper .ProductSliderCell--Zoom img"
            ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );
    this.photoSwipeInstance.listen('close', this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionDropdown");
    this.mainDropdown = this.element.querySelector(
      ".RevolutionDropdown--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionDropdown--InnerContent"
    );
    this.mainButton = this.element.querySelector(".RevolutionDropdown--Button");

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange() {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl
        .querySelector('[value="' + value + '"]')
        .setAttribute("checked", "true");
    }
    this.mainButton.querySelector(".RevolutionDropdown--Title").innerHTML =
      innerContent;
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event, target) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionDropdown--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {

    var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionDropdown--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
      }
    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    var isOpen = target.getAttribute("aria-expanded") === "true";
    if (isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    var siblings = new DomHelper().getSiblings(
      target.parentElement,
      ".RevolutionDropdown"
    );
    siblings.forEach(function (item) {
      item
        .querySelector(".RevolutionDropdown--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionDropdown--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionDropdown--Content").style.display = "none";
    });

    if (this.popover == true) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      trapFocus(this.mainDropdown);
      if(document.querySelector('#sidebarDrawer').getAttribute('aria-expanded') == "true"){
        document.querySelector('.SidebarDrawer--Wrapper').style.overflow = "visible";
      }
    }

    target.setAttribute("aria-expanded", true);
    target.parentElement
      .querySelector(".RevolutionDropdown--Content")
      .setAttribute("aria-hidden", false);
    target.parentElement.querySelector(
      ".RevolutionDropdown--Content"
    ).style.display = "block";
    window.addEventListener("click", this.onClickOutsideListener);

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );
  }

  closeDropdown(target) {
    var closestDropdown = target.closest(".RevolutionDropdown");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionDropdown--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionDropdown--Content")
      .setAttribute("aria-hidden", true);
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionDropdown--Content"
      ).style.display = "none";
    }, 300);
    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      const menuDrawer = document.querySelector('#sidebarDrawer');
      if(menuDrawer.getAttribute('aria-expanded') == "true"){
        document.querySelector('.SidebarDrawer--Wrapper').style.overflow = "auto";
      }else{
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }


    }
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
        i = 0,
        _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );

  }

  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    console.log(window.routes.localeRootUrl);
    fetch(shop_domain + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.location.href.indexOf("cart") != -1){
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

class Dropdown {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
  }
  openDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");
    elem.setAttribute('aria-hidden','false');
    dropdownButton.setAttribute("aria-expanded", true);
    new RevolutionAnimation(dropdownContent, "true").slideDown();
  }

  closeDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");
      elem.setAttribute('aria-hidden','true');
    new RevolutionAnimation(dropdownContent, true).slideUp();
    dropdownButton.setAttribute("aria-expanded", false);
    setTimeout(function () {
      dropdownContent.setAttribute("aria-hidden", "true");
    }, 250);
  }
  toggleDropdown(event, target) {
    event.preventDefault(event);
    const mainDropdown = target.closest(".Dropdown");
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}

(function (funcName, baseObj) {
  "use strict";
  // The public function name defaults to window.docReady
  // but you can modify the last line of this function to pass in a different object or method name
  // if you want to put them in a different namespace and those will be used instead of
  // window.docReady(...)
  funcName = funcName || "docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if (document.readyState === "complete") {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function (callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for docReady(fn) must be a function");
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function () {
        callback(context);
      }, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({ fn: callback, ctx: context });
    }
    // if document already ready to go, schedule the ready function to run
    // IE only safe when readyState is "complete", others safe when readyState is "interactive"
    if (
      document.readyState === "complete" ||
      (!document.attachEvent && document.readyState === "interactive")
    ) {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener("load", ready, false);
        // backup is window load event
        window.addEventListener("DOMContentLoaded", ready, false);
      } else {
        // must be IE
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})("docReady", window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class DomHelper {
  constructor() {}
  getSiblings(element, filter) {
    var includeSelf =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  nodeListToArray(nodeList, filter) {
    var items = [];

    for (var i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }
  outerWidthWithMargin(element) {
    var width = element.offsetWidth,
      style = getComputedStyle(element);

    width += parseInt(style.marginLeft) + parseInt(style.marginRight);

    return width;
  }
  outerHeightWithMargin(element) {
    var height = element.offsetHeight,
      style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
  }
}

class Responsive {
  constructor() {
    var _this = this;

    this.currentBreakpoint = this.getCurrentBreakpoint();

    window.addEventListener("resize", function () {
      var newBreakpoint = _this.getCurrentBreakpoint();

      if (_this.currentBreakpoint === newBreakpoint) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        })
      );

      _this.currentBreakpoint = newBreakpoint;
    });
  }

  matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
      case "phone":
        return window.matchMedia("screen and (max-width: 640px)").matches;

      case "tablet":
        return window.matchMedia(
          "screen and (min-width: 641px) and (max-width: 1024px)"
        ).matches;

      case "tablet-and-up":
        return window.matchMedia("screen and (min-width: 768px)").matches;

      case "pocket":
        return window.matchMedia("screen and (max-width: 1024px)").matches;

      case "lap-and-up":
        return window.matchMedia("screen and (min-width: 1025px)").matches;

      case "desk":
        return window.matchMedia("screen and (min-width: 1280px)").matches;
    }
  }
  getCurrentBreakpoint() {
    if (window.matchMedia("screen and (max-width: 640px)").matches) {
      return "phone";
    }

    if (
      window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
        .matches
    ) {
      return "tablet";
    }

    if (
      window.matchMedia(
        "screen and (min-width: 1008px) and (max-width: 1279px)"
      ).matches
    ) {
      return "lap";
    }

    if (window.matchMedia("screen and (min-width: 1280px)").matches) {
      return "desk";
    }
  }
}
class RevolutionImage {
  constructor() {}

  getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|webp|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  getSupportedSizes(image, desiredSizes) {
    var supportedSizes = [],
      imageWidth = image["width"];

    desiredSizes.forEach(function (width) {
      if (imageWidth >= width) {
        supportedSizes.push(width);
      }
    });

    return supportedSizes;
  }
}

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }
    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.$el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () {};
    this.onClose = options["onClose"] || function () {};
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    window.addEventListener("resize", this.calculateMaxHeightListener);

    this.delegateBody.on('cart-drawer:close-other', this._closeListener);
  }

  maxHeight() {  
    this.element.style.height = window.innerHeight + "px";
    const id = this.element.getAttribute("id");
    if (
      id == "cart" ||
      id == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var header = this.element.querySelector(".CartHeader").offsetHeight;
      var cartItem = this.element.querySelector(".cartItem");
      if (cartItem !== null) {
        var itemHeight = cartItem.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {
        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }

    } else if(id == 'sidebarDrawer'){
 

      var mobileHeader = document.querySelector('.header');
      var mobileHeaderHeight = mobileHeader.offsetHeight;
        this.element.style.height =
          window.innerHeight - mobileHeaderHeight + "px";
      
    
    } else {
      

      var filterBar = document.querySelector('.FilterBar');
      var mobileHeader = document.querySelector('.header');
      var breakpoint = new Responsive().getCurrentBreakpoint();
      if (filterBar !== null && breakpoint == "phone" ) {
        
        var filterBarHeight = filterBar.offsetHeight;
        var mobileHeaderHeight = mobileHeader.offsetHeight;
        this.element.style.height =
          window.innerHeight + "px";
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.maxHeight();
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    if (this.element.getAttribute('id') == 'moreContentDrawer'){
      console.log(event.target);
      this.element.dispatchEvent(
        new CustomEvent("usps-drawer:open", { bubbles: true, detail: {'id':event.target.dataset.text } })
      );
    }
    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

      setTimeout(() => {
        var count = window.theme.cartCount;
        var options = JSON.parse(this.element.getAttribute("data-settings"));
        
            }, 200);

    }
    if (this.isOpen) {
      return;
    }


    this.element.dispatchEvent(
      new CustomEvent("cart-drawer:close-other", { bubbles: true })
    );

    this.maxHeight();

    if (this.element.getAttribute("id") == "sidebarDrawer") {
      document.querySelector(".SidebarDrawer__Close").style.display = "block";
      document.body.querySelector("#shopify-section-header").style.zIndex = "99";
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    } else if (this.element.getAttribute("id") == "favoritesDrawer") {
      this.element.dispatchEvent(
        new CustomEvent("favorite-product:open", {
          bubbles: true,
        })
      );
    } else if (this.element.getAttribute('id') == 'filterDrawer' ){
      document.body.querySelector("#shopify-section-header").style.zIndex = "99";
    }

    if (this.element.classList.contains('reviewDrawer')){
      this.element.querySelector('.spr-button').focus();
    }

    this.element.setAttribute("aria-expanded", "true");
    this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);

    var focus = this.element.querySelectorAll('[data-scrollable]');
      focus.forEach((item) =>{
        bodyScrollLock.disableBodyScroll(item);
      });
    document.body.classList.add("scrollLock");
    this.isOpen = true;
    setTimeout(() => {
      trapFocus(this.element);
    }, 400);
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }
    if (event) {
      event.preventDefault();
    }
    const id = this.element.getAttribute('id');
    if (this.element.getAttribute("id") == "sidebarDrawer") {
    }
    document.body.classList.remove("scrollLock");


    if (id == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
     
    }
    this.element.setAttribute("aria-expanded", "false");
      if(this.element.classList.contains('sizeDrawer_Wrapper') == true && document.body.querySelector('#cart').getAttribute('aria-expanded') == "true"){

        return;
      }

      if (id == 'filterDrawer' || id == 'sidebarDrawer'){
        document.body.querySelector("#shopify-section-header").style.zIndex = "6";
      }

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);
    removeTrapFocus(this.element);
    this.closeAnimation(this.element);
    this.isOpen = false;
    bodyScrollLock.clearAllBodyScrollLocks();
    this.onClose();
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      var contentToAnimate = this.element.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.setupAnimation(item, i);
      });
    }
  }
  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(104%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }
  setupAnimation(animatedItem, i) {
    var options = [],
      query = "";
    options["integer"] = i;
    options["type"] = animatedItem.getAttribute("data-animation");

    var _this = this;
    if (this.intersectionObserver[i]) {
      this.intersectionObserver[i].disconnect();
    }
    this.intersectionObserver[i] = new IntersectionObserver(
      this.reveal.bind(this, options),
      {
        threshold: 0.3,
      }
    );
    if (window.theme.enableImageAnimations) {
      query = ".animatedContent";
    }
    new DomHelper()
      .nodeListToArray(
        animatedItem.querySelectorAll(".animatedContent, .animatedContent")
      )
      .forEach(function (item) {
        _this.intersectionObserver[i].observe(item);
      });
  }

  reveal(a, results) {
    var _this = this;
    var integer = a["integer"];
    var toReveal = [];
    results.forEach(function (result) {
      if (result.isIntersecting || result.intersectionRatio > 0) {
        // isIntersecting does not exist on Samsung Android browser
        toReveal.push(result.target);
        _this.intersectionObserver[integer].unobserve(result.target);
      }
    });

    if (toReveal.length === 0) {
      return;
    }

    switch (a["type"]) {
      case "elementFromTop":
        this.elementFromTop(toReveal);
        break;

      case "elementFromBottom":
        this.elementFromBottom(toReveal);
        break;

      case "elementFromRight":
        this.elementFromRight(toReveal);
        break;

      case "elementFromLeft":
        this.elementFromLeft(toReveal);
        break;
      case "elementFromLeftBig":
        this.elementFromLeftBig(toReveal);
        break;
      case "elementFromRightBig":
        this.elementFromRightBig(toReveal);
        break;
      case "elementScaleIn":
        this.elementScaleIn(toReveal);
        break;
      case "elementScaleOut":
        this.elementScaleOut(toReveal);
    }
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

      if (this.options['noVariants'] == "true"){
        this.toggleAddButton();
      }
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
    if(quantityEl){
      quantity = quantityEl.value();
    }
    if (window.variantInfo.show_icon) {
      var buySvg =
        '<svg class="mr-m" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.516 9.6672H10.8328V3.984C10.8328 3.8048 10.6792 3.6768 10.5256 3.6768C10.372 3.6768 10.2184 3.8304 10.2184 3.984V9.6672H4.48396C4.30476 9.6672 4.17676 9.8208 4.17676 9.9744C4.17676 10.128 4.33036 10.2816 4.48396 10.2816H10.1672V15.9648C10.1672 16.144 10.3208 16.272 10.4744 16.272C10.628 16.272 10.7816 16.1184 10.7816 15.9648V10.3072H16.4648C16.644 10.3072 16.772 10.1536 16.772 10C16.772 9.8464 16.6952 9.6672 16.516 9.6672Z" fill="#F4F4F4"/></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity){quantity = 1;}


      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='ml-s'>" +
          Shopify.formatMoney(
            this.options['price'] * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;

  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.counter = 0;
    this.counter = this.element.querySelector(".counter");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    const countInterval = setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const countDate = new Date(
      "March 3, 2030," + this.options["countdownTime"]
    );
    const nOfDays = this.options["countdownDays"];
    const difference = countDate - dateNow;

    var textDays = 0;
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
    const todaysDay = dateNow.getDay();

    const textHours = Math.floor((difference % days) / hours);
    const textMinutes = Math.floor((difference % hours) / minutes);
    const textSeconds = Math.floor((difference % minutes) / seconds);

    if (todaysDay == 1) {
      textDays = nOfDays;
    } else if (todaysDay == 0) {
      textDays = 0;
    } else {
      textDays = nOfDays - todaysDay;
      if (textDays < 0) {
        const mDays = todaysDay % nOfDays;
        textDays = nOfDays - mDays;
      }
    }

    if (this.options["excludeWeekends"] && todaysDay == 5) {
      textDays = textDays + 2;
    } else if (this.options["excludeWeekends"] && todaysDay == 6) {
      textDays = textDays + 1;
    }

    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
    if (textDays > 0 && nOfDays > 1) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}
customElements.define("countdown-element", Countdown);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelector(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    new AddToCart(this.element);
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }
  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".CartHeader").offsetHeight + "px"
      );

      if (this.options["showRecommendations"]) {
       
          this.loadRecommendations();
      
      }
    }
  }
  updateItemQuantity(event, target) {
    event.preventDefault();
    target
      .closest(".cartItem")
      .querySelector(".itemLoader")
      .classList.add("is-visible");
    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(shop_domain + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function () {
      _this.renderCart(target.getAttribute("data-id"), true);
    });
  }

  onProductAdded() {
    var _this = this;
    this.renderCart().then(function () {
      _this.sidebarDrawer.openDrawer();
    });
  }

  renderCart(lineNumber, quantityChange) {
    this.pageLoader.style.width = 100 + "%";

    var _this = this;
    return fetch(shop_domain + "/?section_id=cart-drawer", {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });
  }

  replaceContent(html, lineNumber, quantityChange) {
    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );

    var number = this.tempOptions["itemCount"];
    this.cartCount.innerHTML = "(" + number + ")";
    window.theme.cartCount = parseInt(number);
    if (lineNumber) {
      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber + " .cartItem--Informations"
      );
      if (cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceChild(
          itemToReplaceWith,
          cartNodeParent.querySelector(".cartItem--Informations")
        );
      } else {
        cartNodeParent.classList.add("removing");
        cartNodeParent.animate(
          [
            // keyframes
            { transform: "translateY(0px)", opacity: "1" },
            { transform: "translateY(30px)", opacity: "0" },
          ],
          {
            // timing options
            duration: 500,
            fill: "forwards",
          }
        );
        setTimeout(() => {
          cartNodeParent.remove();
        }, 500);

        if (this.options["showRecommendations"]) {
          
            this.loadRecommendations();
         
        }
      }

      if (number > 0) {


        if(this.element.querySelector('.CartFooter--Total')){
          this.element.querySelector('.CartFooter--Total').replaceChild(
            tempElement.querySelector('.totals__subtotal-value'),
            this.element.querySelector('.CartFooter--Total').querySelector(".totals__subtotal-value ")
          );
        }
       
      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableImageAnimations) {
          const mainPartchildren = mainPartParent.querySelector(
            "#main-cartItems"
          );
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
      if (window.theme.enableImageAnimations) {
        new RevolutionAnimation(this.element);
      }
    }
    setTimeout(() => {

      if (this.options["showRecommendations"] && !quantityChange) {
    
          this.loadRecommendations();
       
      }
      var focus = _this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.sidebarDrawer.maxHeight();
    }, 200);
  }

  loadRecommendations() {
    if (this.options["productId"] == "") {
      var url = "?section_id=cart-recommendations";
    } else {
      var url =
        shop_domain +
        "/recommendations/products?section_id=cart-recommendations&product_id=" +
        this.options["productId"] +
        "&limit=10";
    }

    var _this = this;
    return fetch(url).then(function (response) {
      return response
        .text()
        .then(function (content) {
          var container = document.createElement("div");
          container.innerHTML = content;
          var z = container.querySelector(".cartUpsell").innerHTML;

          
          var x = _this.element.querySelector(".CartMobileRecommendations");
          x.innerHTML = z;
  
  

          const swiper = new Swiper(".swiperUpsell", {
            // Default parameters
            slidesPerView: 2,
            spaceBetween: 17,
            threshold: 20,
            loop: false,
            navigation: {
              "nextEl": ".nextEl",
              "prevEl": ".prevEl"
            },
            pagination: {
              "el": ".sidecart_pagination",
              "type": "bullets",
              "clickable": true
            },
           
            breakpoints: {
              1025: {
                slidesPerView: 2,
                spaceBetween: 24,
                pagination: {
                  "el": ".sidecart_pagination",
                  "type": "bullets",
                  "clickable": true
                }
              },
            },
          });

          if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(_this.element);
          }

        })
        .catch((e) => {
          console.error(e);
        });
    });
  }

}
customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define("slider-text", SliderTextSection);



class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {
    var breakpoint = new Responsive().getCurrentBreakpoint();

    if (singleItem == true) {
      var imageContainers = this.element.querySelectorAll(
        ".Banner__ImageContainer--Swap"
      );
    } else {
      var currentIndex = this.carousel.swiperElement.activeIndex;
      var domHelper = new DomHelper();
      var cellElement = this.carousel.swiperElement.slides[currentIndex];
      var imageContainers = domHelper.nodeListToArray(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }
    if (imageContainers.length === 0) {
      return;
    }
    var imageToReveal = null;

    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0].querySelector(".Banner__Image");
    } else {
      if(imageContainers[1]){
        imageToReveal = imageContainers[1].querySelector(".Banner__Image");
      } else {
        imageToReveal = imageContainers[0].querySelector(".Banner__Image");
      }
  
    }
    if (
      imageToReveal &&
      imageToReveal.getAttribute("data-loaded-image") != true
    ) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");

      imageToReveal.src = replaceUrl;
      imageToReveal.setAttribute("data-loaded-image", "true");
    }
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.carousel = this.element.querySelectorAll(".MenuSlideshow");
    var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.domHelper = new DomHelper();

    if (this.options.sticky) {
      this.toggleSticky();
    }
    this.bindEvents();
    this.menuOverlapHandler();

  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".Header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".HeaderWrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("Header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
    document.documentElement.style.setProperty(
      "--header-height",
      this.element.clientHeight + "px"
    );
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function() {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    window.addEventListener("scroll", this.toggleColorListener);
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-hasMenu='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this), true
    );
  }

  updateMenuPosition(target){
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${target.getBoundingClientRect().top + target.offsetHeight + 3}px`
    );
  }

  openMenu(event, target) {

    this.element.dispatchEvent(
      new CustomEvent("menu:open", { bubbles: true })
    );

    if (event.type === "mouseenter" && target !== event.target) {return;}
    this.updateMenuPosition(target);
    this.element.classList.remove("Header--Transparent");
    target.setAttribute("aria-expanded", "true");

    this.domHelper
      .getSiblings(target, '[aria-expanded="true"]')
      .forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
      });


  }

  closeMenu(event, target) {

    if (event.type === "mouseleave" && target !== event.target){return;}
    if (this.options["transparent"]) {
      this.element.classList.add("Header--Transparent");
    }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
        item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor();

  }

  toggleColor() {
    if ( window.pageYOffset > 25){
      this.element.classList.add('Header--Scrolled');
      this.element.classList.remove('Header--notScrolled');
      document.documentElement.style.setProperty(
        "--header-height",
        this.element.clientHeight + "px"
      );
    } else {
      this.element.classList.remove('Header--Scrolled');
      this.element.classList.add('Header--notScrolled');
      document.documentElement.style.setProperty(
        "--header-height",
        this.element.clientHeight + "px"
      );
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);
    this.dropdown = new Dropdown(this.element);
    this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {
      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
var trans = new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.createObserver();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInicialization();
    } else {
      setTimeout(function () {
        console.log('here');
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    if (event.detail.element.getAttribute("data-id") != "productSwiperElement"){return;}
    this.elementPosition = this.element.getAttribute("data-image-position");

      if (event.detail.currentIndex == this.elementPosition) {
        if (!this.element.getAttribute("loaded")) {
          var node = document.createElement("div");
          node.appendChild(
            this.element
              .querySelector("template")
              .content.firstElementChild.cloneNode(true)
          );
          this.element.appendChild(node.firstElementChild).focus();
          this.element.setAttribute("loaded", true);
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options['viewport']) {
              this.videoPlayer.play();
              this.createObserver();
            }
          }
        } else {
          if (!this.videoPlayer) {
            this.checkLoaded();
          } else {
            if (this.options['viewport']) {
              this.videoPlayer.play();
              this.createObserver();
            }
          }
        }
      } else if (this.videoPlayer) {
        this.videoPlayer.pause();
      }

  }

  videoPlayerInicialization() {
    var _this = this;
    if (!this.element.getAttribute("loaded")) {
      var node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }
    console.log('here');
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      var isMobile = true;
    } else {
      var isMobile = false;
    }

    let img_plh = "";
    let aspect_ratio = "";
    let src = "";
    let host = "html5";
    if (isMobile) {
      if (this.options["control_var"]) {
        src = this.options["videom"];
      } else if (this.options["video_inside_media"]) {
        src = this.options["videom"]["sources"][1]["url"];
      } else {
        src =
          "https://www.youtube.com/watch?v=" +
          this.options["videom"]["external_id"];
        host = this.options["videom"]["host"];
      }
      img_plh = this.options["plh_mob"];
      if (this.options["aspect_mob"]) {
        aspect_ratio = this.options["aspect_mob"];
      } else {
        aspect_ratio = "9:16";
      }
    } else {
      if (this.options["control_var"]) {
        src = this.options["videod"];
      } else if (this.options["video_inside_media"]) {
        src = this.options["videod"]["sources"][1]["url"];
      } else {
        src =
          "https://www.youtube.com/watch?v=" +
          this.options["videod"]["external_id"];
        host = this.options["videom"]["host"];
      }
      img_plh = this.options["plh_desk"];
      if (this.options["aspect_desk"]) {
        aspect_ratio = this.options["aspect_desk"];
      } else {
        aspect_ratio = "16:9";
      }
    }
    if (host == "youtube") {
      var type = "video/youtube";
    } else {
      var type = "video/mp4";
    }

    if(!this.options['plh']){
      img_plh = false;
    }

    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: this.options["viewport"],
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: img_plh,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: true,
        pictureInPictureToggle: false,
        volumeControl: false,
        progressControl: {
          seekBar: false,
        },
        fullscreenToggle: true,
        playbackRateMenuButton: false,
      },
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    var videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";
      if (_this.trueObserver == false && _this.options['pause']) {
        _this.createObserver();
      }
    });
  }


  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
    });

    const target = this.element;
    observer.observe(target);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
        }
        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.play();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (this.videoPlayer) {

          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let responsive = new Responsive();
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      this.dropdown = new Dropdown(this.element);
    }
  }
}
customElements.define("footer-component", FooterComponent);

class DropdownSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.dropdown = new Dropdown(this.element);
  }
}
customElements.define("dropdown-section", DropdownSection);

class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.carouselElementThumbs = this.element.querySelector(
      ".ProductSlider--Thumbnails"
    );

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    let breakpoint = new Responsive().getCurrentBreakpoint();

    if(this.options['slides_number'] > 1 && breakpoint == "phone" || breakpoint == "tablet"){
      if(this.options['show_thumbnails']){
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs
        );

      }else{
        this.carousel = new RevolutionSwiper(
          this.carouselElement
        );
      }
    }

    this.changeImageQuality();
    this.valuesWrap = this.element.querySelectorAll(
      ".ProductOption--ValusWrapper"
    );
    var localPickup = this.element.querySelector("#LocalPickup");
    if (localPickup) {
      new Drawer(this.querySelector("#LocalPickup"));
    }
    this.reviewsHandler();
    new AddToCart(this.element);
    new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");

    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));
  }
  
  reviewsHandler(){
    var _this = this;
    var observer = new MutationObserver(function(mutations) {
       if (_this.element.querySelector('.spr-button')) {
           _this.element.querySelector('.spr-summary-actions').style.display = "none";
         if(_this.element.querySelector('.ReviewFooter')){
           const node = _this.element.querySelector('.reviewStatus');


          node.appendChild(_this.element.querySelector('#productReview').content.firstElementChild.cloneNode(true));
          const number = parseFloat(_this.element.querySelector('#productReview').content.firstElementChild.getAttribute('data-value'));
          const numberR = parseFloat(_this.element.querySelector('#productReview').content.firstElementChild.getAttribute('data-count'));
            node.querySelector('value').innerHTML = number.toFixed(2);
            node.appendChild(_this.element.querySelector('.spr-summary-starrating'));
            const div = document.createElement('div');
            div.innerHTML = `(${numberR})`
            div.classList.add('u-p6');
            div.style.color = "#D4D0CF";
            _this.element.querySelector('.spr-summary-starrating').append(div);
            _this.element.getAttribute('data-pid');

         }
         _this.element.querySelector('.reviewsContentEnter').appendChild(_this.element.querySelector('.spr-form'));
         _this.element.querySelector('.spr-form').style.display = "block";


          observer.disconnect();
        }
    });

    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});



  }


  updateImage() {
    var imageID = event.detail.new_image;
    var selector = "#Image--" + imageID;
    var imageIndex = this.element
      .querySelector(selector)
      .getAttribute("data-image-position");
    this.carousel.selectCell(parseInt(imageIndex));
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(
      ".ProductSliderCell:first-child img"
    );
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.bindEvents();
  }

  bindEvents(){
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    });
  }


  onQuantityChange(){
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }


  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = ".ProductInfo--Prices";
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);


        if (source && destinations) {
        destinations.forEach((destination) => {
          destination.innerHTML = source.innerHTML;
        });
      }

        const quantityButton = document.querySelector('.QuantityHandler');
        if(quantityButton){
          const source = html.querySelector('.QuantityHandler');
          if (source && quantityButton) quantityButton.innerHTML = source.innerHTML;
        }
        this.toggleAddButton();
      });
  }



  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelector(".ProductPage--ATC"),
          addButtonInner = addButton.querySelector(".SelfAlign"),
          quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');
          if(quantityEl){
                quantity = quantityEl.value;
          }
    if (window.variantInfo.show_icon) {
      var buySvg =
      '<svg class="mr-m" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.516 9.6672H10.8328V3.984C10.8328 3.8048 10.6792 3.6768 10.5256 3.6768C10.372 3.6768 10.2184 3.8304 10.2184 3.984V9.6672H4.48396C4.30476 9.6672 4.17676 9.8208 4.17676 9.9744C4.17676 10.128 4.33036 10.2816 4.48396 10.2816H10.1672V15.9648C10.1672 16.144 10.3208 16.272 10.4744 16.272C10.628 16.272 10.7816 16.1184 10.7816 15.9648V10.3072H16.4648C16.644 10.3072 16.772 10.1536 16.772 10C16.772 9.8464 16.6952 9.6672 16.516 9.6672Z" fill="#F4F4F4"/></svg>';
    } else {
      var buySvg = "";
    }

    if (!addButton) return;
    if (!quantity){quantity = 1;}

    if (this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButtonInner.innerHTML = buySvg + window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='ml-s'>" +
          Shopify.formatMoney(
            this.currentVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.innerHTML =
        buySvg + window.variantStrings.addToCart + priceElement;
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.blogWrapper = this.element.querySelector("#BlogArticleWrapper");
    this.blogElement = this.element.querySelectorAll(".BlogArticle");

    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    if (this.options.layout == "masonary") {
      window.addEventListener('resize', this.setupGetInspredGrid.bind(this));
     document.addEventListener('DOMContentLoaded', this.setupGetInspredGrid.bind(this));
    }
  }

  setupGetInspredGrid() {
    const el = this.blogWrapper;
    if (el.lengtth == 0) {
      return;
    }

    var currentClientWidth = Math.max(
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );


    const items = this.blogElement;
    const lastItem = items[items.length - 1];
    if (items.length == 0) {
      return;
    }

    const itemWidth = parseFloat(window.getComputedStyle(lastItem).width);

    let maxItemHeight = lastItem.offsetHeight;
    const numberOfCols = Math.floor(currentClientWidth / itemWidth);

    let isSmall = false;
    let rowTemp = 0;
    let maxHeight = 0;
    items.forEach((item, i) => {
      let rowHeiht = 0;


      const col = i % numberOfCols;
      const row = Math.floor(i / numberOfCols);

      /*calculate height of row, global max item height */
      if (row > 0) {
        for (let i = 1; i <= row; i++) {
          const preParalelIndex = col + (i - 1) * numberOfCols;
          const paralelEl = items[preParalelIndex];
          rowHeiht = rowHeiht + paralelEl.offsetHeight;

          maxItemHeight =
            maxItemHeight < paralelEl.offsetHeight
              ? paralelEl.offsetHeight
              : maxItemHeight;
        }

        maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
      }

      /* initialize is small flag for that row */
      if (row !== rowTemp) {
        rowTemp = row;

        isSmall = row % 2 != 0;
      }

      const left = col * itemWidth;

      const top = rowHeiht.toFixed(2);

      if (top !== "NaN") {
        const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, overflow problem

        if (!isHidden) {
          const padding = isSmall
            ? `${90 + Math.random() * 20}%`
            : `${110 + Math.random() * 40}%`;

          item.querySelector(".BlogItem--Wrapper").style.paddingTop =
            padding + "px";

          const myitem = item;
          myitem.style.cssText = "left:" + left + "px;top:" + top + "px";

          isSmall = !isSmall;
        }
      }
    });

    var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
    el.style.cssText =
      "width:" +
      numberOfCols * itemWidth +
      "px;height:" +
      elHeight +
      "px;margin:auto";
  }
}
customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.searchElement = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');
    this.queryMap = {};
    this.searchResultsElement = this.element.querySelector(".SearchInitial");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }
    this.carouselElement = this.element.querySelector(".SearchCollection");
    if (this.carouselElement) {
      if (new Responsive().matchesBreakpoint("lap-and-up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.bindEvents();
  }


  bindEvents() {
    this._preventSubmissionListener = this.preventSubmission.bind(this);
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateElement.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );
    this.searchInputElement.addEventListener(
      "keydown",
      this._preventSubmissionListener
    );
    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="clear-search"]',
      this.resetSearch.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  

  initCarousel() {
    if (new Responsive().matchesBreakpoint("lap-and-up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.closeSearch();
      return;
    }
    var _this = this;
    var target = event.target;
    if (
      !this.searchElement.querySelector(".SearchSlide ") &&
      this.options["product"] &&
      this.options["collection"] == ""
    ) {
      this.loadRecommendations();
    }

    target.parentElement
      .querySelector(".SearchWrapper")
      .setAttribute("aria-hidden", false);
    this.pageOverlayElement.classList.add("is-visible");
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    this.closeListener = _this.closeSearch.bind(this);
    this.pageOverlayElement.addEventListener("click", _this.closeListener);
    bodyScrollLock.disableBodyScroll(
    this.searchElement.querySelector("[data-scrollable]"),bodyScrollLockOptions
    );
    this.isOpen = true;


    setTimeout(() => {
      _this.searchInputElement.focus();
    }, 200);

    document.body.querySelector("#shopify-section-header").style.zIndex = "99";
    document.body.querySelector("#shopify-section-announcement-bar").style.zIndex = "99";
    if (this.options["transparent"]) {
      setTimeout(() => {
        document.body
          .querySelector("#header")
          .classList.remove("Header--Transparent");
      }, 15);
    }
    this.element.dispatchEvent(
      new CustomEvent("cart-drawer:close-other", { bubbles: true })
    );

  }

  closeSearch() {
    event.preventDefault();
    var _this = this;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(_this.searchElement,bodyScrollLockOptions);
    document.body.querySelector("#shopify-section-header").style.zIndex = "5";
    document.body.querySelector("#shopify-section-announcement-bar").style.zIndex = "5";
    document.body.querySelectorAll(".SearchWrapper").forEach((item, i) => {
      item.setAttribute("aria-hidden", true);
    });
    _this.pageOverlayElement.classList.remove("is-visible");
    document.body.querySelector(
      "#shopify-section-header"
    ).style.backgroundColor = "transparent";
    document.body.style.position = "relative";
    document.body.style.width = "100%";
    if (_this.options["transparent"]) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    }

    this.isOpen = false;
  }

  preventSubmission(event) {
    if (event.keyCode === 13 && window.theme.searchMode !== "product") {
      event.preventDefault();
    }
  }

  onInput(event) {

    this.lastInputValue = event.target.value;
    var passTrough = false;
    var _this = this;
    this.searchResultsElement.style.opacity = 0;
    if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = _this.searchElement.querySelector(".SearchInput");
      passTrough = true;
      el.setAttribute("value", _this.lastInputValue);
      el.value = _this.lastInputValue;
    } else {
      if (event.keyCode === 13) {
        return;
      }

     

      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    var queryOptions = {
      method: "GET",
      credentials: "same-origin",
    };
    if (_this.options["suggestedCollections"]) {
      const url = `${shop_domain}/search/suggest.json?q=${encodeURIComponent(this.lastInputValue)}&resources[type]=collection&resources[limit]=1`;
      var queries = [
        fetch(
          url,
          queryOptions
        )
        ];
    }

    if (window.theme.searchMode !== "product") {
      const url = `${shop_domain}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=${window.theme.searchMode.replace("product,", "")}`;
      queries.push(
        fetch(
          url,
          queryOptions
        )
      );
    }
    const url = `${shop_domain}/search?view=ajax&q=${encodeURIComponent(this.lastInputValue)}*&type=product`;
    queries.push (
      fetch(
        url,
        queryOptions
      ),
    );




    this.queryMap[this.lastInputValue] = true;

    Promise.all(queries).then(function (responses) {
      if (_this.lastInputValue !== event.target.value && passTrough == false) {
        return;
      }
      delete _this.queryMap[event.target.value];

      Promise.all(
        responses.map(function (response) {
        return response.text();
        })).then(function (contents) {

        //resultExists determines if there is any other results like products, articles or pages

        var resultExistsObject = [],
          resultExists,
          collectionHTML = document.createElement('div');

          contents.forEach((item, i) => {

            if (item.includes('collections')){
              let collectionInner = '',
                    collectionObject = JSON.parse(item);
              if(collectionObject.resources.results.collections.length > 0){
                collectionHTML.innerHTML = _this.layouts( _this.lastInputValue,false,false,'collectionLayout');
                resultExistsObject.push(true);
                    collectionObject.resources.results.collections.forEach(function (entry) {
                    collectionInner += _this.layouts(entry.url, entry.featured_image.url, entry.title, 'collectionItem');
                  });
                  collectionHTML.querySelector('.Segment__Content').innerHTML = collectionInner;
              }else{
                resultExistsObject.push(false);
                collectionHTML.innerHTML = _this.layouts(false, false, false, 'collectionItemNoResults');
              }

              contents[i] = collectionHTML.innerHTML;

            }else{
              if(item.includes('js-noresult')){
                resultExistsObject.push(false);
              }else{
                resultExistsObject.push(true);
              }

            }
          });

          if(resultExistsObject.includes(true)){
            resultExists = true;
          }else{
            resultExists = false;
          }
        
          if (window.theme.showRecentSearches) {
            _this.recentSearches();
          }

        _this.loadData(resultExists, contents);

      });
    });
  }

  loadData(resultExists, data){
    this.element.querySelector('.clearSearch').setAttribute('aria-hidden','false');
    switch(resultExists){
      case true:
        let content = "";
        let tempContent = "";
        let block = document.createElement('div');
        data.forEach((item, i) => {
          
          if (i < 2) {
            block.innerHTML += item;

          } else {
            tempContent += item;
          }

        });
        content = `<div class="Collection--Article">${block.innerHTML}</div>` + tempContent;
        
      this.searchResultsElement.innerHTML =
      `<div class='SearchLayout--2items'>${content}</div>`
      this.searchResultsElement.style.display = "flex";
      break;

      case false:
        
        let tempElement = document.createElement("div");
            tempElement.innerHTML = data[1];
            
            tempElement = tempElement.querySelector("template").content.firstElementChild.cloneNode(true);

        if (this.options["noResultcollection"]) {
          this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResults');
        } else {
          this.searchResultsElement.innerHTML = this.layouts(tempElement.innerHTML, false, false, 'noResultsNoSuggestions');

        }
        this.searchResultsElement.style.display = "flex";
      break;
    }


    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.searchResultsElement);
    }
    this.searchResultsElement.setAttribute("aria-hidden", "false");
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;


  }

  layouts(string1, string2, string3, type){
    var template = '';
    switch(type){

      case 'collectionLayout':
        template =
        `<div class='SearchLayout__Section--collections SearchLayout__Section--collections--SearchBar' data-animation="elementFromBottom">
          <div class='SearchSegmentHeader SearchSegmentHeader--SearchBar'>
            <span class=' u-h5'>${window.languages.collections}</span>

          </div>
          <div class='Segment__Content u-p5'></div>
        </div>`;
      break;

        case 'collectionItem':
        template =

        `<a href="${string1}" class='SearchCollectionContent'>
              <h5 class='u-p5 mb-l'>${string3}</h5>
            </a>    `;
        break;

        case 'collectionItemNoResults':
        template =
        `<div class='searchSegment'>
          <div class="SearchSegmentHeader">
            <span class=" u-h5">${window.languages.collections}</span>
          </div>
          <div class="Segment__Content">
            <p class="SegmentNoResult u-p5">${window.languages.no_results}</p>
          </div>
        </div>`;
        break;

        case 'noResults':
        template =
        `<div class="SearchLayout__Section Search--Recommendations-noResults">${string1}</div>\n`;
        break;

        case 'noResultsNoSuggestions':
        template =
        `<div class="SearchLayout__Section Search--Recommendations-noResultsAll">${string1}</div>\n`;
        break;

    }


    return template;
  }


  loadRecommendations() {
    var _this = this,
      product_to_search = _this.options["product"],
      url =
        shop_domain +
        "/recommendations/products?section_id=search_suggested&product_id=" +
        product_to_search +
        "&limit=8";

    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement("div");
        var contentjq = document.createElement("div");
        contentjq.innerHTML = content;
        container.innerHTML = contentjq.innerHTML;
        const newSwiper = _this.element.querySelector(
          ".SearchInitial--Products"
        );
        newSwiper.innerHTML = container.querySelector(
          ".ProductRecommendations"
        ).innerHTML;
        _this.initCarousel();
        if (window.theme.enableImageAnimations) {
          new RevolutionAnimation(newSwiper);
        }
        new AddToCart(_this.element);
      });
    });
  }

 resetSearch() {
    let initialProducts = this.searchResultsElement.querySelector(".SearchInitial--Products"),
      initialLayout = this.initialSearchLayout.querySelector(".SearchInitial--Recents");

    this.searchResultsElement.classList.remove("SearchInitial--SecondView");
    this.searchResultsElement.style.display = "";

    this.element.querySelector('.clearSearch').setAttribute('aria-hidden','true');
    if (initialLayout) { initialLayout.style.opacity = 0; }
    if (initialProducts) { initialProducts.style.opacity = 0; }

    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

    const el = this.searchElement.querySelector(".Search__Form");
    el.value = "";
    el.removeAttribute("value");
    this.searchElement.querySelector(".SearchInput").value = "";
    this.searchResultsElement.setAttribute("aria-hidden", "false");

    if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    if (window.theme.showSuggestedSearches) { this.getSuggestedSearches(); }
    if (this.options["product"] && this.options["collection"] == "") { this.loadRecommendations(); }
    if (window.theme.enableImageAnimations) { new RevolutionAnimation(this.element); }

    initialLayout = this.element.querySelector(".SearchInitial--Recents");
    if (initialLayout) { initialLayout.style.opacity = 1; }
    if (initialProducts) { initialProducts.style.opacity = 1; }

    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
  }

  recentSearches() {
    this.searchResultsElement.style.opacity = 0;


    if (this.lastInputValue === "") {
      this.initialSearchLayout.style.opacity = 0;
      this.resetSearch();
      return;
    }

    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) {}
    }
  }

  getRecentSearches() {
    var appendString = "";
    var items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    var appElement = this.searchElement.querySelector(
      ".Search--Recent__results"
    );
    if (items.length > 0) {
      items.forEach((id, index) => {
        appendString =
          appendString +
          "<li tabIndex='0' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      appElement.innerHTML = appendString;
    } else {
      var appEl = this.searchElement.querySelector(".Search--Recent");
      appEl.style.display = "none";
    }
  }
  getSuggestedSearches() {
    var appendString = "";
    const arr = this.options.items;

    if (arr.length == 0 ){return;}
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 5; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }
    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true && this.element.querySelector(".Contact-Btn")) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else if(this.element.querySelector(".Contact-Btn")) {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${shop_domain}/variants/${variantId}/?section_id=pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() {}

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup__Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(shop_domain + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);

class AnimationWrapper extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
  }
}
customElements.define("animation-wrapper", AnimationWrapper);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.handleOpenOptions();
    if (this.options.edit_mode == true) {
      this.options.delay = 0;
      this.openNewsletter();
    }
  }

  handleOpenOptions() {
    let sessionKey = sessionStorage.getItem("popup-seen");
    var localKey = localStorage.getItem("popup-seen");
    if (this.options.show_only_once == true && localKey == "true") {
      return;
    }
    if (sessionKey != "true") {
      if (this.options.scroll_amount > 0) {
        this.scrollListener = this.scrollListener.bind(this);
        document.addEventListener("scroll", this.scrollListener);
      } else {
        this.openNewsletter();
      }
    }
  }

  scrollListener() {
    var _this = this,
      body = document.body,
      html = document.documentElement;
    let docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    let percScrolled = (window.scrollY / docHeight) * 100;
    if (percScrolled >= _this.options.scroll_amount) {
      _this.openNewsletter();
    }
  }

  openNewsletter() {
    var _this = this;
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      this.onClickOutsideListener = this.closeNewsletter.bind(this);
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      sessionStorage.setItem("popup-seen", true);
      localStorage.setItem("popup-seen", true);
      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter.bind(this)
      );
    }, 1000 * _this.options.delay);
  }

  closeNewsletter() {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );
    document.removeEventListener("scroll", this.scrollListener);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);





class InstagramSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
      var images = new Array();
      var boxes = new Array();
  this.delegateElement = new Delegate(this.element);
  this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
  var _this = this;
  var observer = new MutationObserver(function(mutations) {
     if (_this.element.querySelector('.instafeed-container')) {
      var allElements = _this.element.querySelectorAll('.instafeed-container');
      allElements.forEach((item, i) => {
        const img = item.querySelector('img');
        if(img){
              images.push(img.getAttribute('data-src'));
        }
      });
          observer.disconnect();
          _this.element.querySelectorAll('.InstagramImageWrapper').forEach((item, i) => {
            item.querySelector('img').setAttribute('data-src', images[i]);
            item.querySelector('img').setAttribute('src', images[i]);
          });
          setTimeout(document.querySelector('#insta-feed').style.display = "none", 50);
      }
  });
  observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
  }
  cleanSelector(selector){
    (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function(n){
        selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
    });
    return selector;
  }
}
customElements.define("instagram-section", InstagramSection);

class LocalizationSelectors extends HTMLElement {
      constructor() {
        super();
        this.element = this;
        this.bindEvents();
      }

      bindEvents() {
        this.isPageLoaded =
          document.readyState === "complete" ||
          document.readyState === "loaded" ||
          document.readyState === "interactive";
        if (!this.isPageLoaded) {
          window.addEventListener("load", this.onPageLoaded.bind(this));
        } else {
          this.onPageLoaded();
        }
      }

      onPageLoaded(){
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
        var location = this.element.getAttribute('data-settings');
        if (location == "sidebarMenu") {
          var additionalOverlay = true;
        } else {
          var additionalOverlay = false;
        }
        if (breakpoint != "phone" && breakpoint != "tablet") {
          if (selectBoxes.length > 0) { 
            selectBoxes.forEach((item, i) => {
              new RevolutionSelectbox(
                item
              );
            });
          }
        } else {
          if (selectBoxes.length > 0) { 
            selectBoxes.forEach((item, i) => {
              new RevolutionSelectbox(
                item, true, additionalOverlay
              );
            });
          }
        }
      }
    }
    customElements.define("localization-selectors", LocalizationSelectors);


    
class GiftOption extends HTMLElement {
      constructor(){ 
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.popup = new Popup(this.element, true);
        this.pageLoader = document.body.querySelector(".pageLoader");

        this.bindEvents();
        this.checkGift();
        
    
      }
      bindEvents() {
        
      this.delegateElement.on('click', '[data-action="toggle-gift"]', this.toggleGift.bind(this));
      document.addEventListener("cart:rerendered", this.checkGift.bind(this));
      }


      toggleGift(event){
        const giftProduct = document.querySelector('[data-gift="true"]');
        if (giftProduct){
          this.removeGift(giftProduct);
        } else {
          this.addGift(event);
        }

    }

    removeGift(giftProduct){
      const _this = this;
      const key = giftProduct.dataset.key;
      fetch(shop_domain + "/cart/change.js", {
        body: JSON.stringify({
          id: key,
          quantity: 0,
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function () {
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true
          })
        );
      });
    
    }
    
      addGift(event){
        
        var _this = this;
        var addToCartButton = event.target;
        this.pageLoader.style.width = 100 + "%";
        addToCartButton.setAttribute("disabled", "disabled");

        const items = [];
        const myId = event.target.dataset.gift
        items.push({
          id: myId,
          quantity: 1,
        });
      

        fetch(shop_domain + "/cart/add.js", {
          body: JSON.stringify({
            items: items,
          }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        }).then(function (response) {
          if (response.ok) {
            if (window.location.href.indexOf("cart") != -1){
              location.reload();
              return;
            }
            addToCartButton.removeAttribute("disabled");
            _this.element.dispatchEvent(
              new CustomEvent("product:added", {
                bubbles: true,
                detail: {
                  variant: myId,
                  quantity: 1,
                },
              })
            );
          } else {
            response.json().then(function (content) {
              if (_this.element.querySelector(".ProductForm--Error")) {
                _this.element
                  .querySelector(".ProductForm--Error")
                  .classList.add("visible");
                setTimeout(function () {
                  _this.element
                    .querySelector(".ProductForm--Error")
                    .classList.remove("visible");
                }, 2500);
                _this.pageLoader.style.left = "unset";
                _this.pageLoader.style.right = 0 + "px";
                _this.pageLoader.style.width = 0 + "%";
                setTimeout(() => {
                  _this.pageLoader.style.left = 0 + "px";
                  _this.pageLoader.style.right = "unset";
                }, 550);
              } else {
                var errorMessageElement = document.createElement("span");
                errorMessageElement.className = "u-p4 accent";
                errorMessageElement.innerHTML = content["description"];
                addToCartButton.removeAttribute("disabled");
                addToCartButton.insertAdjacentElement(
                  "afterend",
                  errorMessageElement
                );
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
                _this.pageLoader.style.left = "unset";
                _this.pageLoader.style.right = 0 + "px";
                _this.pageLoader.style.width = 0 + "%";
                setTimeout(() => {
                  _this.pageLoader.style.left = 0 + "px";
                  _this.pageLoader.style.right = "unset";
                }, 550);
              }
            });
          }
        });
      }
    
    

      checkGift(){
        setTimeout(() => {
        const giftProduct = document.querySelector('[data-gift="true"]');
        if (giftProduct){ 
          this.element.querySelector(".notAgreeGift_Wrapper").classList.add('hidden');
          this.element.querySelector(".AgreeGift_Wrapper").style.display = "flex";
        } else {
    
          document.querySelector(".notAgreeGift_Wrapper").classList.remove('hidden');
          document.querySelector(".AgreeGift_Wrapper").style.display = "none";
        }
      }, 200);
    
      }
    
      
    }
    customElements.define("gift-option", GiftOption);
    

class sectionTabs extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.newSpec = this.element.parentElement;
    this.delegateElement = new Delegate(this.element);
    this.specBtn = this.element.querySelector('#spec-title');
    this.bindEvents();
  }
  bindEvents(){
    this.delegateElement.on('click', '[data-action="toggle-specification"]', this.showSpecification.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-formulas"]', this.showFormulas.bind(this));
  }

  showFormulas(event, target){
    const id = target.getAttribute('data-id');
    this.element.querySelectorAll('.specification-data').forEach((item) => {
    item.classList.add('hidden');
  });
    const formulas = this.element.querySelectorAll(`[data-open="${id}"]`);
    formulas.forEach((item) =>{
      item.classList.remove('hidden');
    });

    

    this.element.querySelectorAll('#spec-title').forEach((item,i) => {
    item.classList.remove('active');
  });
  target.classList.add('active');



  }



  showSpecification(event, target){
    const id = target.getAttribute('data-id');
    this.element.querySelectorAll('.specification-data').forEach((item,i) => {
    item.classList.add('hidden');
  });

    this.element.querySelector('#'+ id).classList.remove('hidden');

    this.element.querySelectorAll('#spec-title').forEach((item,i) => {
    item.classList.remove('active');
  });
  target.classList.add('active');
  }
}
customElements.define("section-tabs", sectionTabs);

class InspirationDrawer extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);
      this.sidebarDrawer = new Drawer(this.element);
      this.delegateBody = new Delegate(document.body);
      new AddToCart(this.element);
      this.bindEvents();
    }

    bindEvents(){
      this.delegateElement.on('click','[data-action="toggle-tab"]', this.toggleTab.bind(this));
      document.addEventListener("usps-drawer:open", this.toggleFirstTab.bind(this));
    }

    toggleFirstTab(){


      const allTogglers = this.element.querySelectorAll('.togglerContent');
      const allContent = this.element.querySelectorAll('.pageContent');
      const id = allTogglers[event.detail.id].dataset.id;

      allTogglers.forEach((item) =>{
        item.setAttribute('aria-visible','false');
      })

      allTogglers[event.detail.id].setAttribute('aria-visible','true');

      allContent.forEach((item) =>{
        item.setAttribute('aria-visible','false');
      })

      const openContent = this.element.querySelector(`#${id}`);
      if (openContent){
        openContent.setAttribute('aria-visible','true');
      }
    }

    toggleTab(){
      const allTogglers = this.element.querySelectorAll('.togglerContent');
      const allContent = this.element.querySelectorAll('.pageContent');
      const id = event.target.dataset.id;

      allTogglers.forEach((item) =>{
        item.setAttribute('aria-visible','false');
      })

      event.target.setAttribute('aria-visible','true');

      allContent.forEach((item) =>{
        item.setAttribute('aria-visible','false');
      })

      const openContent = this.element.querySelector(`#${id}`);
      if (openContent){
        openContent.setAttribute('aria-visible','true');
      }
    }

  }
  customElements.define("inspiration-drawer", InspirationDrawer);


    class previewCollections extends HTMLElement {
      constructor() {
        super();
        this.element = this;
        if (window.theme.enableImageAnimations) {
          new RevolutionAnimation(this.element);
        }
        this.delegateElement = new Delegate(this.element);
        this.bindEvents();
      }

      bindEvents(){
        this.delegateElement.on(
          "mouseover",
          '[data-action="toggle-image"]',
          this.toggleImage.bind(this)
        );

        this.delegateElement.on(
          "mouseleave",
          '[data-action="toggle-image"]',
          this.toggleImage.bind(this)
        );
      }

      toggleImage(){
  
        const id = event.target.dataset.handle;

        const allImages = this.element.querySelectorAll('.previewCollections--deskImage');
        allImages.forEach((item) => {
          item.setAttribute('aria-hidden','true');
        });
        if(this.element.querySelector(`#Preview__${id}`)){
          this.element.querySelector(`#Preview__${id}`).setAttribute('aria-hidden','false');
        } else{
          this.element.querySelector('#Preview__Default').setAttribute('aria-hidden','false');
        }
       
      }
    }
    customElements.define("preview-collections", previewCollections);
    


    class ProductCardActions extends HTMLElement {
      constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.bindEvents();
      }
    
      
        bindEvents(){
          this.delegateElement.on(
            "click",
            '[data-action="change-item"]',
            this.getItem.bind(this)
          );
        }


        getItem(event){

          const _this = this;
          event.preventDefault();
        const url = `${shop_domain}/search?view=item&q=id:${event.target.dataset.id}*&type=product;`
        return fetch(url).then(function (response) {
          return response.text().then(function (content) {

            _this.replaceItem(content);
        });
    
      });
    }
    

    replaceItem(content){
      var container = document.createElement("div");
      container.innerHTML = content;
      var newItem = container.querySelector("product-card-actions").innerHTML;
    
      this.element.innerHTML = newItem;
      this.dispatchEvent(
        new CustomEvent("favorites:render", { bubbles: true })
      );
    }
    
      }
      customElements.define("product-card-actions", ProductCardActions);

class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.sidebarDrawer = new Drawer(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.loader = this.element.querySelector(".loader");
    this.cartCount = document.querySelector(".FavoritesCount");
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.toggleFavorites();
    this.bindEvents();
  }
  unbindEvents(){
        document.removeEventListener('favorite-product:open', this.onFavoritesOpenListener);

          document.removeEventListener(
          'click',
            this._addToFavoritesL
          );

  }
  bindEvents(){


 if(!document.body.classList.contains('listener')){
   this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
   this._addToFavoritesL =  this.addToFavorites.bind(this);
   this.delegateBody.on('click', '[data-action="toggle-favorites"]', this._addToFavoritesL);
     document.body.classList.add('listener');
    document.addEventListener('favorite-product:open', this.onFavoritesOpenListener);
    this.delegateBody.on("favorites:render", this.toggleFavorites.bind(this));
 }


  }


  onFavoritesOpen() {
    var _this = this;
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    
    });
    this.sidebarDrawer.isOpen = true;
  }

  maxHeight() {
    var footer = this.element.querySelector(".CartDrawer--Footer");
    if(footer){
      var footerH = footer.offsetHeight;
    }

    this.element.querySelector(".CartItems--Wrapper").style.height =
      window.innerHeight - footerH + "px";
  }

  getSearchQueryStrings() {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    // If we are on a product template, we make sure to remove the main product from the related product
    const bucketSize = 10.0;
    const idBuckets = [];
    items.forEach((id, index) => {
      const key = Math.floor(index / bucketSize);
      if (!idBuckets[key]) {
        idBuckets[key] = [];
      }
      idBuckets[key].push(id);
    });
    return idBuckets.reduce((acc, vall) => {
      const string = vall
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR ");

      acc.push(string);
      return acc;
    }, []);
  }

  rerenderFavorites(event, elementToAnimate) {
    this.loader.classList.add("is-visible");
    var _this32 = this;
    var queryStrings = this.getSearchQueryStrings();
    const promises = [];
 
    
    if (queryStrings.length == 0) {
      this.loader.classList.remove("is-visible");
      fetch("/?section_id=favorites-drawer").then(function (content) {
        content.text().then(function (html) {
          _this32.replaceContentFav(html);
          _this32.loader.classList.remove("is-visible");
          _this32.loadRecommendations();
        });
      });

    }
    queryStrings.forEach((string) => {
      promises.push(
        fetch("/search?view=favorites&type=product&q=" + string, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    });
    promises.reduce(async (acc, val, index) => {
      const content = await val.then((response) => response.text());
      const container = this.element;
      if (!container.length) {
        _this32.replaceContentFav(content);
        _this32.loader.classList.remove("is-visible");
        _this32.maxHeight();
      } else {
        this.loader.classList.remove("is-visible");
      }
    }, Promise.resolve());

    return Promise.resolve();
  }

  replaceContentFav(html) {
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var number = tempElement
      .querySelector(".countFav")
      .getAttribute("data-count");
    var cartNodeParent = this.element.querySelector(".CartDrawer");
    cartNodeParent.replaceChild(
      tempElement.querySelector("#cartData"),
      this.element.querySelector("#cartData")
    );
    this.toggleFavorites();
    this.loader.classList.remove("is-visible");
    var focus = this.element.querySelectorAll('[data-scrollable]');
   
    focus.forEach((item) =>{
      bodyScrollLock.disableBodyScroll(item);
    });
    return true;
  }

  toggleFavorites() {

   
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var favorites = document.querySelectorAll(".ProductCard--Favorites");
    if(document.body.querySelector('.emptyHearthH')){
    if(items.length > 0){
      document.body.querySelector('.emptyHearthH').style.display = "none";
      document.body.querySelector('.brokenHearthH').style.display = "flex";
    }else{
      document.body.querySelector('.emptyHearthH').style.display = "flex";
      document.body.querySelector('.brokenHearthH').style.display = "none";
    }}
    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");
   
      if (state == "not-active" && items.includes(myID)) {
 
        item.querySelector(".brokenHearth").style.display = "flex";
        item.querySelector(".emptyHearth").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!items.includes(myID)) {
        item.querySelector(".brokenHearth").style.display = "none";
        item.querySelector(".emptyHearth").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });
  }

  removeFromFavorites(productId) {
    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    items = items.filter((c) => c != productId);

    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
    } catch (error) {
      console.log(error);
    }
    var _this = this;
    this.toggleFavorites();
    if (this.sidebarDrawer.isOpen == true) {
      this.rerenderFavorites().then(function () {
        new AddToCart(_this.element);
      });
    }
  }

  loadRecommendations() {

    var _this = this;
    var url =
      "/recommendations/products?section_id=fav-recommendations&product_id=" +
      this.options["productId"] +
      "&limit=6";
    return fetch(url).then(function (response) {
      return response.text().then(function (content) {
        var container = document.createElement("div");
        container.innerHTML = content;

        if(container){
            var z = container.querySelector(".favUpsell").innerHTML;
          var x = _this.element.querySelector(".FavoritesRecommendations");
          x.innerHTML = z;
        }


        const swiper = new Swiper(".swiperUpsell", {
          // Default parameters
          slidesPerView: 2.2,
          spaceBetween: 16,
          navigation: false,
          loop: false,
          slidesOffsetAfter: 16,
          slidesOffsetBefore: 16,
          navigation: {
            nextEl: ".swiperNextCart",
            prevEl: ".swiperPrevCart"
          },
          pagination: {
            el: ".favoritePaginatio",
            type: "bullets"
          },
          breakpoints: {
            1024: {
                slidesPerView: 2.02,
                spaceBetween: 24,
                slidesOffsetAfter: 32,
                slidesOffsetBefore: 32
            },
          },
        });
        new AddToCart(x);
        _this.toggleFavorites();
        if (window.theme.enableImageAnimations) {
          new RevolutionAnimation(_this.element);
        }
      });
    });
  }


  addToFavorites(event) {
      var _this = this;
    event.preventDefault();

    var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
    var productId = event.target.getAttribute("data-id");

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId) && productId != "") {
      items.unshift(productId);
    } else {
      this.removeFromFavorites(productId, false);
      //   this._favoritesNumber();
      return;
    }
    // Then, we save the current product into the local storage, by keeping only the 50 most recent
    try {
      localStorage.setItem(
        "productFavorites",
        JSON.stringify(items.slice(0, 50))
      );
      //    this._favoritesNumber();
      this.toggleFavorites();
      if (this.sidebarDrawer.isOpen == true) {
    this.rerenderFavorites().then(function () {
      new AddToCart(_this.element);
    });  }
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);

class SwiperAll extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.getAttribute("data-settings"));
    new RevolutionSwiper(this.element.querySelector(".swiper"));

  }

}
customElements.define("swiper-wrapper", SwiperAll);



class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (window.theme.enableImageAnimations) {
      new RevolutionAnimation(this.element);
    }
    this.main = this;
    this.delegateElement = new Delegate(this.element);
    this.faqs = this.element.querySelectorAll('.Faq-Section');
    this.faqs.forEach((item) => {
      this.createObserver(item);
    });
    this.bindEvents();
  }

  bindEvents(){
    const navItems = document.querySelectorAll('.FAQNav--rowLink')
    const navNames = document.querySelectorAll('.nav--name')
    function setActive(e){
      navNames.forEach(listItem => {
        listItem.classList.remove("active");
      })
    
      e.target.classList.add('active');
     
    }

   
    navItems.forEach(listItem => {
      listItem.addEventListener("click", setActive)
    })

  }


  createObserver(item) {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(item), {
      threshold: 1,
    });

    const target = item;
    this.observer.observe(target);
  }

  handleIntersect(entries, items) {
    var _this = items;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {

        const id = entry.target.getAttribute('id');
        const navItems = document.querySelectorAll('.FAQNav--rowLink')
    const navNames = document.querySelectorAll('.nav--name')

      navNames.forEach(listItem => {
        listItem.classList.remove("active");
      })
      const selector = document.querySelector(`.FAQNav--rowLink[href="#${id}"] .nav--name`);
      if (!selector) return;
      document.querySelector(`.FAQNav--rowLink[href="#${id}"] .nav--name`).classList.add('active');
     
   
      }
    });
  }


 
}
customElements.define("faq-section", FAQSection);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            new RevolutionSwiper(this.querySelector('.swiper'));
            if (window.theme.enableImageAnimations || window.theme.enableTextAnimations) {
              new RevolutionAnimation(this);
              _this.dispatchEvent(
                new CustomEvent("favorites:render", { bubbles: true })
              );
            }

            new AddToCart(_this);
          }

        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '-100px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/*
class CollectionPagination extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

   const element = this.element.querySelector(".Dropdown[data-options]");
   if(element && this.element.dataset.loaded == 'false'){
    this.options = JSON.parse(element.dataset.options);
    this.collectionSize = JSON.parse(element.dataset.products);
      if (this.options && this.element.dataset.loaded == 'false'){
        this.element.setAttribute('data-loaded', 'true');
      this.getCollections();
    }

   }
   
}

getSections() {
  return [
      {
          id: 'CollectionProductGrid',
          section: document.getElementById('CollectionSection').dataset.id,
      }
  ]
}

getCollections(){
  const _this = this;
  const sections = this.getSections();
  const promises = [];
  this.mainContainer = document.body.querySelector("#mainCollectionHolder");
  this.mainContainer.innerHTML = '';

  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlString = urlSearchParams.toString();


  for (const [key, value] of Object.entries(this.options)) {
    let itterations = this.collectionSize[key];
          itterations = Math.ceil(itterations / 30);
         
    for (let i = 1; i <= itterations; i++){
      if (i == 1){
        promises.push(
          fetch(`/collections/${value}?section_id=collection_ajax&${urlString}`, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      } else {
        promises.push(
          fetch(`/collections/${value}?section_id=collection_ajax&${urlString}&page=${i}`, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    }
   
  
  }
  this.renderData(promises);
}

 renderData(promises){ 
  const _this = this;
  Promise.all(promises).then(function (responses) {
    Promise.all(
      responses.map(function (response) {
      return response.text();
      })).then(function (contents){
       contents.forEach((item) => {
       
        const el = document.createElement("div");
        const string = item.replace('data-loaded="false"', 'data-loaded="true"');
          
        el.innerHTML = string;
        let collectionGrid = el.querySelectorAll("product-card-actions");
        let collectionTitle = el.querySelector('#CollectionProductGrid');
        let collectionHandle = collectionTitle.dataset.collectionhandle;
        let title = collectionTitle.dataset.collection;
      
        const divider = document.createElement('div');
              divider.classList.add('u-h4');
              divider.classList.add('collectionDivider');
              divider.setAttribute('data-content', collectionHandle);
              divider.setAttribute('id',`JumpTo${collectionHandle}`);
              divider.innerHTML = title;
              
          if (collectionGrid.length > 0){
            _this.mainContainer.append(divider);
            let observeElement = _this.mainContainer.querySelector(`[data-content="${collectionHandle}"]`);
            _this.createObserver(observeElement);
          }
      
           collectionGrid.forEach((item) =>{
          item.classList.add('appended');
          _this.mainContainer.append(item);
        });

       });
 
    });
  });
}

createObserver(element) {
  this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
    threshold: 0.5,
  });
  console.log(element);
  this.observer.observe(element);
}

handleIntersect(entries) {
  var _this = this;
  entries.forEach((entry) => {
    if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
      console.log(entry.target);
 
      const title = entry.target.dataset.content;
      console.log(title);
      const menuItem = document.querySelector(`a[data-handle="${title}"]`);
      console.log(menuItem);
      const element = document.querySelector('.dropdownSubitem--Active');
      if (element){
        element.classList.remove('dropdownSubitem--Active');
      }
  
      if (menuItem){
        menuItem.classList.add('dropdownSubitem--Active');
      }
      _this.observer.unobserve(_this);
    }
  });
}

}
customElements.define('collection-pagination', CollectionPagination);*/

class CollectionPagination extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.initialize();
    this.delegateBody.on("rerender:collection", this.initialize.bind(this));
    this.delegateElement.on('click','[data-action="close-drawer"]',this.closeDrawer.bind(this));
    this.delegateElement.on('click','[data-action="jump-to-url"]', this.jumpToUrl.bind(this));
  }

  initialize() {
    
    const element = this.element.querySelector(".Dropdown[data-options]");
    if (element && this.element.dataset.loaded === 'false') {
      try {
        this.options = JSON.parse(element.dataset.options);
        this.collectionSize = JSON.parse(element.dataset.products);
        if (this.options) {
          this.element.setAttribute('data-loaded', 'true');
          this.getCollections();
        }
      } catch (error) {
        console.error('Error parsing JSON data:', error);
        // You may also add an error message display to inform the user
      }
    }
  }

  closeDrawer(){
    this.element.dispatchEvent(
      new CustomEvent("cart-drawer:close-other", { bubbles: true })
    );
  }

  getSections() {
    const collectionSection = document.getElementById('CollectionSection');
    if (collectionSection) {
      return [{
        id: 'CollectionProductGrid',
        section: collectionSection.dataset.id,
      }];
    } else {
      console.warn('CollectionSection element not found.');
      return [];
    }
  }

  getCollections() {
    const sections = this.getSections();
    const promises = this.generateFetchPromises();

    this.mainContainer = document.body.querySelector("#mainCollectionHolder");

    this.renderData(promises);
  }

  generateFetchPromises() {
    const promises = [];
    const urlSearchParams = new URLSearchParams(window.location.search);
    const urlString = urlSearchParams.toString();

    for (const [key, value] of Object.entries(this.options)) {
      const iterations = Math.ceil(this.collectionSize[key] / 30);
      for (let i = 1; i <= iterations; i++) {

        const url = `${Shopify.routes.root}collections/${value}?section_id=collection_ajax&${urlString}${i > 1 ? `&page=${i}` : ''}`;

        promises.push(fetch(url, {
          credentials: "same-origin",
          method: "GET",
        }));
      }
    }
    return promises;
  }

  async renderData(promises) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(responses.map(response => response.text()));
      this.mainContainer.innerHTML = '';
      contents.forEach(content => this.appendContent(content));
    } catch (error) {
      console.error('Error fetching or parsing data:', error);
      // You may also add an error message display to inform the user
    }
  }
  

  appendContent(content) {
    const el = document.createElement("div");
    const string = content.replace('data-loaded="false"', 'data-loaded="true"');
    el.innerHTML = string;

    const collectionGrid = el.querySelectorAll("product-card-actions");
    const collectionTitle = el.querySelector('#CollectionProductGrid');
    const collectionHandle = collectionTitle.dataset.collectionhandle;
    const collectionPage = collectionTitle.dataset.page;



    const title = collectionTitle.dataset.collection;

    if (collectionGrid.length > 0) {
      if(collectionPage == 1){
        const divider = this.createDivider(collectionHandle, title);
        this.mainContainer.append(divider);
      }

      let observeElement = this.mainContainer.querySelector(`[data-content="${collectionHandle}"]`);
      this.createObserver(observeElement);
    }

    collectionGrid.forEach(item => {
      item.classList.add('appended');
      this.mainContainer.append(item);
    });

    if (window.location.hash) {
      const hashElement = document.querySelector(window.location.hash);
      if (hashElement) {
        hashElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

  }

  createDivider(collectionHandle, title) {
    const divider = document.createElement('div');
    divider.classList.add('u-h4', 'collectionDivider');
    divider.setAttribute('data-content', collectionHandle);
    divider.setAttribute('id', `JumpTo${collectionHandle}`);
    divider.innerHTML = title;
    return divider;
  }

  createObserver(element) {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });
    this.observer.observe(element);
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting === true) {
        const title = entry.target.dataset.content;
        const menuItem = document.querySelector(`a[data-handle="${title}"]`);
        const element = document.querySelector('.dropdownSubitem--Active');
        if (element) {
          element.classList.remove('dropdownSubitem--Active');
        }
        if (menuItem) {
          menuItem.classList.add('dropdownSubitem--Active');
        }
      }
    });
  }

  jumpToUrl(){
    event.preventDefault();
    console.log(event.target);
    const jumpLocation = event.target.dataset.handle;
    const scrollElement = document.querySelector(`#JumpTo${jumpLocation}`);
    console.log(scrollElement);
    if(scrollElement){
      scrollElement.scrollIntoView(true);
      this.closeDrawer();
    }
  }
}

customElements.define('collection-pagination', CollectionPagination);


class SuccessPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );

    if (window.location.href.indexOf("ewsletter") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
    }

    if (this.options.edit_mode == true) {
      this.options.delay = 0;
      this.openNewsletter();
    }
  }



  openNewsletter() {
    var _this = this;
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      this.onClickOutsideListener = this.closeNewsletter.bind(this);
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );
      sessionStorage.setItem("popup-seen", true);
      localStorage.setItem("popup-seen", true);
      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter.bind(this)
      );
    }, 1000 * _this.options.delay);
  }

  closeNewsletter() {
    this.element.setAttribute("aria-hidden", true);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

  }
}

customElements.define("success-popup", SuccessPopup);